/*  iceberg-ui  */
import { Icon } from '@auviknetworks/iceberg-ui';

/*  MUI  */
import { Box, Chip } from '@mui/material';

/* Shared */
import { FontSizes, ManagementState } from 'application/Shared/Constants';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import ObjectPicker from './Components/ObjectPicker';

class ManagementStage extends Component {
    constructor(props) {
        super(props);
        this.state = { loaded: false, objectPayload: [] };
    }

    componentDidMount() {
        const { shortLabel, t } = this.props;

        const labels = {
            managed: shortLabel
                ? t('Common.managed')
                : t('Common.managedApplication'),
            unmanaged: shortLabel
                ? t('Common.unmanaged')
                : t('Common.unmanagedApplication'),
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            unclassified: shortLabel
                ? t('Common.unclassified')
                : t('Common.unclassifiedApplication')
        };

        const visualPayload = {
            [ManagementState.ManagedApplication]: (
                <Chip
                    icon={
                        <Box sx={{ lineHeight: 0 }}>
                            <Icon size={FontSizes[2]} src="Check" />
                        </Box>
                    }
                    sx={{
                        '& .MuiChip-icon': {
                            color: 'managedPicker.icon.managed'
                        },
                        '& .MuiChip-label': {
                            paddingX: '8px',
                            paddingY: '2px'
                        },
                        backgroundColor: 'managedPicker.background.managed',
                        border: '1px solid',
                        borderColor: 'managedPicker.borderColor.managed',
                        color: 'managedPicker.textColor.managed'
                    }}
                    size="small"
                    label={labels.managed}
                />
            ),
            [ManagementState.UnmanagedApplication]: (
                <Chip
                    icon={
                        <Box sx={{ lineHeight: 0 }}>
                            <Icon size={FontSizes[2]} src="QuestionMark" />
                        </Box>
                    }
                    sx={{
                        '& .MuiChip-icon': {
                            color: 'managedPicker.icon.unmanaged'
                        },
                        '& .MuiChip-label': {
                            paddingX: '8px',
                            paddingY: '2px'
                        },
                        backgroundColor: 'managedPicker.background.unmanaged',
                        border: '1px solid',
                        borderColor: 'managedPicker.borderColor.unmanaged',
                        color: 'managedPicker.textColor.unmanaged'
                    }}
                    size="small"
                    label={labels.unmanaged}
                />
            ),
            // eslint-disable-next-line sort-keys-fix/sort-keys-fix
            [ManagementState.UnclassifiedApplication]: (
                <Chip
                    icon={
                        <Box sx={{ lineHeight: 0 }}>
                            <Icon size={FontSizes[2]} src="Warning" />
                        </Box>
                    }
                    sx={{
                        '& .MuiChip-icon': {
                            color: 'managedPicker.icon.unclassified'
                        },
                        '& .MuiChip-label': {
                            paddingX: '8px',
                            paddingY: '2px'
                        },
                        backgroundColor:
                            'managedPicker.background.unclassified',
                        border: '1px solid',
                        borderColor: 'managedPicker.borderColor.unclassified',
                        color: 'managedPicker.textColor.unclassified'
                    }}
                    size="small"
                    label={labels.unclassified}
                />
            )
        };

        const objectPayload = {};
        Object.keys(visualPayload).forEach((k) => {
            objectPayload[k] = {
                display: t(`Picker.managementState.${k}`),
                displayVisualOnly: visualPayload[k],
                id: k
            };
        });

        this.setState({
            loaded: true,
            objectPayload,
            visualOnlyDefault:
                visualPayload[ManagementState.UnmanagedApplication]
        });
    }

    render() {
        const { loaded, objectPayload, visualOnlyDefault } = this.state;
        if (!loaded) {
            return null;
        }

        return (
            <ObjectPicker
                {...this.props}
                disableClearable
                objectNameField="display"
                objectNameFieldVisualOnly="displayVisualOnly"
                objectPayload={objectPayload}
                visualOnlyDefault={visualOnlyDefault}
            />
        );
    }
}

export default withTranslation()(ManagementStage);
